import { Fun } from 'widgets-for-react'
import {
  CollectionEditorState,
  collectionEditorStateUpdaters,
  initialCollectionEditorState,
} from '../collections/collectionEditor/collectionEditorState'

export type DashboardState = {
  accountExpanded: boolean
  collectionCreatorState: CollectionEditorState
}

export const initialDashboardState: DashboardState = {
  accountExpanded: false,
  collectionCreatorState: initialCollectionEditorState,
}

export const dashboardStateUpdaters = {
  startCreatingUpdater: (state: DashboardState): DashboardState => ({
    ...state,
    collectionCreatorState: collectionEditorStateUpdaters.startEditingUpdater(
      '',
      ''
    )(state.collectionCreatorState),
  }),
  collectionCreatorStateUpdater:
    (
      update: Fun<
        CollectionEditorState,
        CollectionEditorState & { reloadCollections?: boolean }
      >
    ) =>
    (
      state: DashboardState
    ): DashboardState & { reloadCollections?: boolean } => {
      const { reloadCollections, ...newState } = update(
        state.collectionCreatorState
      )
      return {
        ...state,
        collectionCreatorState: newState,
        reloadCollections: reloadCollections,
      }
    },
  toggleAccountExpandable: (state: DashboardState): DashboardState => ({
    ...state,
    accountExpanded: !state.accountExpanded,
  }),
}
